import { queryOptions, useQuery } from '@tanstack/react-query';

const QUERY_KEY = ['national-client-identifier', 'formats'];

const loadNationalClientIdentifierFormats = async () => {
  const { NCI_PLACEHOLDER_BY_COUNTRY, NCI_REGEX_BY_COUNTRY } = await import('@1trading/ts-common/nci');

  return { examples: NCI_PLACEHOLDER_BY_COUNTRY, patterns: NCI_REGEX_BY_COUNTRY };
};

export type NationalClientIdentifierFormats = Awaited<ReturnType<typeof loadNationalClientIdentifierFormats>>;

export const nationalClientIdentifierFormatsQueryOptions = queryOptions({
  gcTime: Number.POSITIVE_INFINITY,
  staleTime: Number.POSITIVE_INFINITY,
  queryFn: loadNationalClientIdentifierFormats,
  queryKey: QUERY_KEY,
  // The cached value holds RegExp instances, which structural sharing would not round-trip.
  structuralSharing: false,
});

export const useNationalClientIdentifierFormats = () => useQuery(nationalClientIdentifierFormatsQueryOptions);
